import React from "react";


const Footer = () => {
    return(
        <div className="footer">
            Built by Urgent Lion LLC
        </div>
    );
}

export default Footer;